import { getParagraph } from '../createRender';

let reverseParseTextView = data => {
    let obj = createRender(data);

    return obj;
}

function createRender(data) {
    if (!data.stem) {
        return {}
    }

    // 题干
    let stem = getParagraph(data.stem.replace(/(?=(blank\d))/g, '#').replace(/(?=(}#"))/g, '#').replace(/(#{#)|(#}#)/g, ''));
    // 答案
    let answer = data.answer ? getAnswer(data.answer) : null;

    const render = { stem, answer };
    return render;
}

const getAnswer = (answer) => {
    try {
        answer = JSON.parse(answer);
    } catch (error) {
        answer = [];
    }

    const tree = transformTree(answer.path, []);

    return tree;
};

const transformTree = (path, tree) => {
    const obj = {};
    const item = Object.keys(path)[0];
    const exercise = path[item];

    obj.number = exercise.number; // 题号
    obj.stage = exercise.stage; // 解题步骤。1：阅读理解，2：推理分析，3：列式解答
    obj.children = []; // 下一题
    tree.push(obj);

    if (exercise.isbranch) {
        const branchs = Object.keys(exercise.answer).sort();
        obj.branchs = branchs; // 分支
        branchs.forEach(branch => {
            transformTree(exercise.answer[branch].path, obj.children);
        });
    } else {
        if (!exercise.answer.isright.is_end) {
            transformTree(exercise.answer.isright.path, obj.children);
        }
    }

    return tree;
};

export { reverseParseTextView };


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/step/createRender.js